import { ChainId } from '@pancakeswap/chains'
import { ASSET_CDN } from 'config/constants/endpoints'

export enum Env {
  PROD = 'production',
  DEV = 'development',
}

export const ENV = process.env.NEXT_PUBLIC_ENV

export const ENV_CHAIN_ID = process.env.NEXT_PUBLIC_ENV === Env.DEV ? ChainId.ENDURANCE_TESTNET : ChainId.ENDURANCE

// export const DOCKMAN_HOST = 'http://copilot.tpddns.cn:19000'
// http://localhost:9310
// https://devnetapi.tesseract.world
export const DOCKMAN_HOST = {
  [ChainId.ENDURANCE_TESTNET]: 'https://tesseract-api1-dev.archivenode.club',
  // [ChainId.ENDURANCE_TESTNET]: 'https://devnetapi.tesseract.world',
  [ChainId.ENDURANCE]: 'https://tesseract-api-origin.fusionist.io',
}
// http://localhost:9729
// https://tesseract-api-testing.fusionist.io
export const NEWAPI_HOST = {
  [ChainId.ENDURANCE_TESTNET]: 'https://tesseract-api2-dev.archivenode.club',
  // [ChainId.ENDURANCE_TESTNET]: 'https://tesseract-api-testing.fusionist.io',
  [ChainId.ENDURANCE]: 'https://tesseract-api.fusionist.io',
}

export const PEAEC_COLLECTION_ID = {
  [ChainId.ENDURANCE]: '648-0xaf8ef2b180fe7cade68643705adae08d1d2791a1',
  [ChainId.ENDURANCE_TESTNET]: '6480-0xbc638689c189b31cb4261566a59625c7db7a018a',
}

export const PLANET_COLLECTION_ID = {
  [ChainId.ENDURANCE]: '648-0x7db2ee56b2c19ea0758631c24415ce3a5ec498f5',
  [ChainId.ENDURANCE_TESTNET]: '6480-0xa5ff822f72ad0e53c379e43228f53ecf6c49e481',
}

export const FMECH_COLLECTION_ID = {
  [ChainId.ENDURANCE]: '648-0x863fc7e04d7b770cfc4e180bc0b9420271399bde',
  [ChainId.ENDURANCE_TESTNET]: '6480-0x3e243df4820042c8687ec51b54471dd5de4e058c',
}

export const SEAPORT_ADDRESS = {
  [ChainId.ENDURANCE]: '0xFF28baa302C29cFcbe898A10d4AD4f3CA574D02F',
  [ChainId.ENDURANCE_TESTNET]: '0xe6A51926775C88442b8456BCfa6123BC702dc09f',
}

export const FEE_ADDRESS = {
  [PEAEC_COLLECTION_ID[ChainId.ENDURANCE]]: '0xB4aa77f87218739245F7493f126cf52A298224F9',
  [PEAEC_COLLECTION_ID[ChainId.ENDURANCE_TESTNET]]: '0x44fcC28ccC6C765E91dEDcEd37ddF4ff70515a7A',
  [PLANET_COLLECTION_ID[ChainId.ENDURANCE]]: '0xA0494fEF411962260B87dc99Ec83419944C1FFF8',
  [PLANET_COLLECTION_ID[ChainId.ENDURANCE_TESTNET]]: '0x44fcC28ccC6C765E91dEDcEd37ddF4ff70515a7A',
  [FMECH_COLLECTION_ID[ChainId.ENDURANCE]]: '0xA0494fEF411962260B87dc99Ec83419944C1FFF8',
  [FMECH_COLLECTION_ID[ChainId.ENDURANCE_TESTNET]]: '0x44fcC28ccC6C765E91dEDcEd37ddF4ff70515a7A',
}

export const FEE_BASIS_POINTS = 500
export const DEFAULT_NFT_IMAGE = `${ASSET_CDN}/default-nft.png`
export const DEFAULT_AVATAR = `${ASSET_CDN}/default-avatar.png`
export const DEFAULT_COLLECTION_AVATAR = `${ASSET_CDN}/default-collection-avatar-3.png`
export const DEFAULT_COLLECTION_BANNER = `${ASSET_CDN}/default-collection-banner.png`

export const RECYCLE_CONTRACT_ADDRESS = {
  [ChainId.ENDURANCE]: '0x2E9ACb9B3b95D5BE81EB2C19b79544E4EC1009f7',
  [ChainId.ENDURANCE_TESTNET]: '0x64e1C67C6785ae81b9cf417fD2C0d30d20c51d12',
}

export const NFT_SUBGRAPH_URL = {
  [ChainId.ENDURANCE]: 'https://endurance-subgraph-v2.fusionist.io/subgraphs/name',
  [ChainId.ENDURANCE_TESTNET]: 'https://endurance-subgraph-testnet.fusionist.io/subgraphs/name',
}

export const RECYCLE_ABI = [
  {
    inputs: [],
    name: 'peekBuybackAmount',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'buyback',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
]
